import BreadCrumb from "./BreadCrumb";
import * as selectors from "./breadCrumb.selectors";
import * as slice from "./breadCrumb.reducers";

export const {
  name,
  actions: { setSelectedTab, setSelectedSubTab },
  reducer,
} = slice;

export const { selectSelectedTab, selectSelectedSubTab } = selectors;

export default BreadCrumb;
